<i18n src="./resources/locales.json" />

<template>
  <v-dialog v-model="dialog" persistent max-width="400px">
    <v-card color="surface lighten-1">
      <v-card-title class="header">
        {{ $t('title') }}
      </v-card-title>
      <v-card-text>
        <v-checkbox v-model="includeHistory" :label="$t('includeHistory')" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel()">
          {{ $t('buttons.cancel') }}
        </v-btn>
        <v-btn color="primary" depressed @click="startConference()">
          {{ $t('buttons.start') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const CONFERENCE_CONFIRMED_EVENT = 'conference-confirmed';
const CONFERENCE_CANCELLED_EVENT = 'conference-cancelled';
export default {
  name: 'EcsGroupChatSetupDialog',

  data() {
    return {
      dialog: false,
      includeHistory: true
    };
  },

  methods: {
    open() {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.$once(CONFERENCE_CONFIRMED_EVENT, resolve);
        this.$once(CONFERENCE_CANCELLED_EVENT, reject);
      });
    },
    startConference() {
      this.dialog = false;
      this.$emit(CONFERENCE_CONFIRMED_EVENT, { includeHistory: this.includeHistory });
      this.$off(CONFERENCE_CANCELLED_EVENT);
    },
    cancel() {
      this.dialog = false;
      this.$emit(CONFERENCE_CANCELLED_EVENT, 'USER_ACTION:CANCEL');
      this.$off(CONFERENCE_CONFIRMED_EVENT);
      this.restartCard();
    },
    restartCard() {
      this.includeHistory = true;
    }
  }
};
</script>
<style scoped>
h3 {
  letter-spacing: 0.1em;
}
</style>
